import types from 'actions/types';
import { getOptionsGlobal as _getOptionsGlobal } from 'services/global.service';

const ACTIVE_ONLY_ORG_FIELDS = ['company', 'business', 'cluster', 'store'];

const sortObjectKeysDeep = (value) => {
  if (Array.isArray(value)) {
    return value.map(sortObjectKeysDeep);
  }

  if (value && typeof value === 'object') {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        result[key] = sortObjectKeysDeep(value[key]);
        return result;
      }, {});
  }

  return value;
};

const normalizeGlobalOptionParams = (field, params = {}) => {
  const normalizedParams = params ? { ...params } : {};

  if (ACTIVE_ONLY_ORG_FIELDS.includes(field) && normalizedParams.is_active === undefined) {
    normalizedParams.is_active = 1;
  }

  return normalizedParams;
};

const buildGlobalOptionCacheKey = (field, params = {}) => `${field}:${JSON.stringify(sortObjectKeysDeep(params || {}))}`;

const showConfirmModal = (message, confirmCallback, labelAccept, labelRefuse) => {
  return {
    type: types.SHOW_CONFIRM_MODAL,
    payload: { message, labelAccept, labelRefuse, confirmCallback },
  };
};

const hideConfirmModal = () => ({
  type: types.HIDE_CONFIRM_MODAL,
});

const triggerSidebar = () => ({
  type: types.TRIGGER_SIDEBAR,
});

const showNotify = (payload) => ({
  type: types.SHOW_NOTIFY,
  payload: payload,
});

const hideNotify = () => ({
  type: types.HIDE_NOTIFY,
});

const showNotifyHeader = (payload) => async (dispatch) => {
  dispatch(hideNotify);
  dispatch(showNotify(payload));
};

const getOptionsGlobalRequest = (type, field, cacheKey) => ({
  type,
  field,
  cacheKey,
});

const getOptionsGlobalSuccess = (type, payload, field, params, cacheKey) => ({
  type,
  payload,
  field,
  params,
  cacheKey,
});

const getOptionsGlobalFailure = (type, payload, field, params, cacheKey) => ({
  type,
  payload,
  field,
  params,
  cacheKey,
});

const getOptionsGlobal = (field, params) => async (dispatch) => {
  const typeActions = `GET_GLOBAL_OPTIONS_${field.toUpperCase()}`;
  const normalizedParams = normalizeGlobalOptionParams(field, params);
  const cacheKey = buildGlobalOptionCacheKey(field, normalizedParams);
  return new Promise((resolve, reject) => {
    dispatch(getOptionsGlobalRequest(`${typeActions}_REQUEST`, field, cacheKey));
    _getOptionsGlobal({
      type: field,
      ...normalizedParams,
    })
      .then((response) => {
        dispatch(getOptionsGlobalSuccess(`${typeActions}_SUCCESS`, response, field, normalizedParams, cacheKey));
        resolve(response);
      })
      .catch((error) => {
        dispatch(getOptionsGlobalFailure(`${typeActions}_FAILURE`, error, field, normalizedParams, cacheKey));
        reject(error);
      });
  });
};

export {
  showConfirmModal,
  hideConfirmModal,
  triggerSidebar,
  showNotify,
  hideNotify,
  showNotifyHeader,
  getOptionsGlobal,
};
